export const COPY_STATUS = {
  IDLE: "idle",
  COPIED: "copied",
  FAILED: "failed",
};

const TOOLTIP_LABELS = {
  [COPY_STATUS.IDLE]: "Click to copy",
  [COPY_STATUS.COPIED]: "Copied to clipboard",
  [COPY_STATUS.FAILED]: "Could not copy",
};

export const getCopyTooltipLabel = status =>
  TOOLTIP_LABELS[status] || TOOLTIP_LABELS[COPY_STATUS.IDLE];
